module.exports = __webpack_public_path__ + "assets/img/vp-logo.da87f58e.png";